<template>
    <div class="Cyber-page">
        <!-- 返回、标题 -->
        <div
            class="Cyber-page-header"
            :style="{ paddingTop: 25 + statusBarHeight + 'px' }"
        >
            <div class="Cyber-page-header-return" @click="handleClosePage">
                <img
                :src="require('@/assets/images/YuliApp/CyberportCoupon/Native_button_return.png')"
                />
            </div>
            <h1 class="Cyber-page-header-title"></h1>
        </div>
        <!-- 顶部区域 -->
        <div class="Cyber-page-top">
            <img
                :src="require('@/assets/images/YuliApp/CyberportCoupon/index_banner.png')"
            />
            <!-- 饭票合成弹窗 -->
            <!-- <div class="Cyber-page-button Cyber-page-top-buttonPoint" @click="goGetItHandle">
                Go get it >
            </div> -->
        </div>
        <!-- 列表域 -->
        <div 
            class="Cyber-page-list"
            :style="{ paddingTop: statusBarHeight + 'px' }"
        >
            <div class="Cyber-page-list-content">
                <div class="Cyber-page-list-content-header">
                    <div class="Cyber-page-list-content-header-title">
                        <span>My Coupon</span>
                        <img
                            :src="require('@/assets/images/YuliApp/CyberportCoupon/index_title_underline.png')"
                        />
                    </div>
                    <div class="Cyber-page-list-content-header-record" @click="RecordPageHandle(true)">
                        Records >
                    </div>
                </div>
                <!-- 数据列表 -->
                <div class="Cyber-page-list-content-listView">
                    <div class="Cyber-page-list-content-listView-item" 
                         v-for="(item, index) in listData" 
                         :style="{
                            background: item?.coupon_type && `url(${require(`@/assets/images/YuliApp/CyberportCoupon/ticket_item_bg_type${item?.coupon_type}.png`)}) no-repeat top left`,
                            backgroundSize: '100% 100%',
                         }"
                         @click="ticketHandle(item)"
                         :key="index">
                        <div class="Cyber-page-list-content-listView-item-left">
                            <span class="Cyber-page-list-content-listView-item-left-label">{{ item.title }}</span>
                            <span class="Cyber-page-list-content-listView-item-left-id">#{{ item.id }}</span>
                        </div>
                        <div class="Cyber-page-list-content-listView-item-right">
                            <img
                                :src="require('@/assets/images/YuliApp/CyberportCoupon/ticket_item_code.png')"
                            />
                        </div>
                    </div>
                    <!-- 数据缺省 -->
                    <div class="Cyber-page-list-content-listView-noData" v-if="listData?.length == 0">
                        <img
                            :src="require('@/assets/images/YuliApp/CyberportCoupon/none.png')"
                        />
                        <span>No Coupon available currently</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 挂载 -->
        <TicketPopup 
            v-show="isShowPopup"
            :ticket="currentTicket"
            @msgHandle="PopupHandle"
        />
        <RecordPage
            v-if="isShowRecordPage"
            :listData="listData"
            @msgHandle="RecordPageHandle"
        />
        <MergeTicketPopup
            v-show="isShowMergeTicketPopup"
            :propList="propList"
            @msgHandle="MergeTicketPopupHandle"
        />
    </div>
</template>
  
<script>
import { onBeforeMount, onMounted, ref, getCurrentInstance } from "vue";
import { useRoute } from 'vue-router';
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
// import {getGuideRoleLanguage} from "@/api/language.js";
import _ from "lodash";
import store from "@/store";
import TicketPopup from "./components/TicketPopup";
import RecordPage from "./components/RecordPage";
import MergeTicketPopup from "./components/MergeTicketPopup";
import { getUnuseTicketList, postMergeTicket, postUseTicket } from "@/api/cyberport.js"
import { ERROR_TEXT } from "@/constants/enums";
import { TOAST_TYPE } from "@/components/Toast/index.vue";

export default {
components: {
    TicketPopup,
    RecordPage,
    MergeTicketPopup
},
props: {
    id: {
        type: Number,
        default: 0,
    },
},
watch: {
    id: {
        async handler(value) {
            
        },
        immediate: true,
        deep: true,
    },
    init: {
        async handler(value) {
            if (!value) {
                return;
            }
            console.log('firstInit');
            await this.firstInit();
        },
        immediate: true,
        deep: true,
    },
},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
    }),
},
setup(props) {
    const {id} = props;
    const { proxy } = getCurrentInstance();
    const route = useRoute();
    const listData = ref([]);
    const propList = ref([
        {
            img: require('@/assets/images/YuliApp/CyberportCoupon/icon_cyber.png'),
            name: 'Cyberport Coupon I',
            desc: 'Cyberport Coupon I Cyberport Coupon I Cyberport Coupon I Cyberport Coupon I ',
            curNumber: 1,
            needNumber: 1,
            prop_type: 5,
        },
        {
            img: require('@/assets/images/YuliApp/CyberportCoupon/icon_port.png'),
            name: 'Cyberport Coupon II',
            desc: 'Cyberport Coupon I Cyberport Coupon I Cyberport Coupon I Cyberport Coupon I ',
            curNumber: 1,
            needNumber: 1,
            prop_type: 5,
        }
    ])
    const isShowPopup = ref(false);
    const isShowRecordPage = ref(false);
    const isShowMergeTicketPopup = ref(false);
    const currentTicket = ref(null);

    onMounted(() => {
        appBridging.getStatusBarHeight();
        const listDataLocal = _.cloneDeep(listData.value);
        listDataLocal?.forEach(item => {
            item.propList = propList.value
        })
        listData.value = listDataLocal;
    });

    /**初始化 */
    const firstInit = async () => {
        proxy.$loading.show();
        try {
            const res = await getUnuseTicketList();
            const { data, props } = res;
            listData.value = data?.map(item => {
                return {
                    ...item,
                    title: item.name
                }
            }) || [];
            propList.value = props?.map(item => {
                return {
                    ...item,
                    img: item.img_url,
                    desc: item.description,
                    curNumber: item.count,
                    needNumber: item.max_limit,
                    prop_type: item.level,
                }
            }) || [];
        } catch (error) {
            proxy.$toast.show({
              msg: ERROR_TEXT.NEXTWORK_ERROR,
              type: TOAST_TYPE.ERROR,
            });
        }
        proxy.$loading.hide();
    }

    /**
     * 票点击处理
     */
    const ticketHandle = (ticket) => {
        console.log(ticket);
        currentTicket.value = ticket;
        isShowPopup.value = true;
    }

    /**记录页监听处理 */
    const RecordPageHandle = (state) => {
        isShowRecordPage.value = state;
    }

    /**
     * 关闭页面
     */
     const handleClosePage = () => {
      appBridging.closePage();
    };

    /**核销弹窗监听处理 */
    const PopupHandle = (state) => {
        if(state == false){
            isShowPopup.value = false;
            return;
        }else if(state == 'reflash'){
            firstInit();
        }
    }

    /**合成弹窗监听处理 */
    const MergeTicketPopupHandle = (state) => {
        if(state == false){
            isShowMergeTicketPopup.value = false;
            return;
        }else if(state == 'reflash'){
            firstInit();
        }
    }

    const goGetItHandle = () => {
        isShowMergeTicketPopup.value = true;
    }

    return {
        handleClosePage,
        ticketHandle,
        RecordPageHandle,
        MergeTicketPopupHandle,
        PopupHandle,
        goGetItHandle,
        firstInit,
        listData,
        propList,
        currentTicket,
        isShowPopup,
        isShowRecordPage,
        isShowMergeTicketPopup
    };
},
};
</script>
  
<style lang="less" scoped>
    .Cyber-page{
        width: 100%;
        height: 100vh;
        background: url("~@/assets/images/YuliApp/CyberportCoupon/index_bg.png")
        no-repeat top left;
        background-size: 100% 100%;
        position: relative;
        box-sizing: border-box;
        overflow: hidden;
        &-header {
            position: relative;
            // bottom: 50px;
            width: 100%;
            height: 45px;
            display: flex;
            &-return {
                width: 64.07px;
                height: 30px;
                text-align: left;
                margin-bottom: 18px;
                img {
                    width: 100%;
                    height: 100%;
                    margin-left: -4px;
                }
            }
            &-title {
                // padding-top: 15px;
                margin-left: calc((100vw / 2) - 64.07px);
                transform: translateX(-50%);
                color: rgba(255, 255, 255, 1);
                font-size: 16px;
                font-weight: 500;
                font-family: "PingFang SC";
                text-align: center;
                line-height: 30px;
            }
        }
        &-top{
            width: 375px;
            height: 215px;
            position: relative;
            img{
                width: 100%;
                height: 100%;
            }
            &-buttonPoint{
                position: absolute;
                bottom: 48px;
                left: 28px;
            }
        }
        &-button{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 89px;
            height: 29px;
            border-radius: 20px;
            opacity: 1;
            border: 1px solid #73572e;
            background: #ffdb5b;
            color: #0d0a0a;
            font-size: 14px;
            font-weight: 500;
            font-family: "PingFang SC";
            text-align: right;
            line-height: 16.8px;
        }
        &-list{
            width: 100%;
            height: calc(100vh - 269px);
            padding: 0 8px;
            box-sizing: border-box;
            position: absolute;
            bottom: 0;
            left: 0;
            &-content{
                width: 100%;
                height: 100%;
                background: url("~@/assets/images/YuliApp/CyberportCoupon/index_silder_bg.png")
                no-repeat top left;
                background-size: 100% 100%;
                &-header{
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    box-sizing: border-box;
                    padding: 21px 11px 0 19px;
                    margin-bottom: 32px;
                    &-title{
                        position: relative;
                        width: fit-content;
                        color: #22242c;
                        font-size: 18px;
                        font-weight: 600;
                        font-family: "PingFang SC";
                        text-align: left;
                        line-height: 16px;
                        img{
                            width: 163px;
                            height: 32px;
                            position: absolute;
                            bottom: -22px;
                            left: -14px;
                        }
                    }
                    &-record{
                        color: #000000bf;
                        font-size: 16px;
                        font-weight: 600;
                        font-family: "PingFang SC";
                        text-align: left;
                        line-height: 16px;
                    }
                }
                &-listView{
                    width: 100%;
                    height: calc(100vh - 369px);
                    overflow: scroll;
                    box-sizing: border-box;
                    &-item{
                        width: 320px;
                        height: 74px;
                        background: url("~@/assets/images/YuliApp/CyberportCoupon/ticket_item_bg.png")
                        no-repeat top left;
                        background-size: 100% 100%;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        padding: 12px;
                        margin: 0 auto;
                        margin-bottom: 10px;
                        &-left{
                            display: flex;
                            flex-direction: column;
                            font-family: "PingFang SC";
                            text-align: left;
                            color: #181a21f2;
                            &-label{
                                font-size: 15.52px;
                                color: rgba(234, 225, 218, 0.95);
                                font-weight: 600;
                                margin-bottom: 10px;
                            }
                            &-id{
                                color: rgba(234, 225, 218, 0.95);
                                font-size: 12.61px;
                                font-weight: 400;
                            }
                        }
                        &-right{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            img{
                                width: 40px;
                                height: 38px;
                            }
                        }
                    }
                    &-noData{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        margin-top: 100px;
                        img{
                            width: 100px;
                            height: 100px;
                            margin-bottom: 20px;
                        }
                        span{
                            color: #ffffff;
                            font-size: 18px;
                            font-weight: 500;
                            font-family: "PingFang HK";
                            text-align: center;
                        }
                    }
                }
            }
        }
    }
</style>